import {
    configReducer,
    formReducer,
    gridReducer,
    menuLateralReducer
} from 'skrit-web-framework/reducers';

import motoscatReducer from './motoscat';
import cestaReducer from './cesta';

/* Temporary function */
function reduceReducers(...reducers) {
    return (previous, current) =>
        reducers.reduce((p, r) => r(p, current), previous);
}

/* Custom root reducer */
const skritApp = reduceReducers(
    formReducer,
    configReducer,
    gridReducer,
    menuLateralReducer,
    motoscatReducer,
    cestaReducer
);

export default skritApp;
